import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import VeracodeConfigListing from './VeracodeConfigListing'
import VeracodeCredentialsForm from './VeracodeCredentialsForm'

export default function VeracodePullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={VeracodeCredentialsForm}
            PullConfigListingView={VeracodeConfigListing}
            RunOnDemandButtonText={'Sync tool applications'}
        />
    )
}
